import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../components/api'
import Table from 'react-bootstrap/Table'
import { v4 as uuidv4 } from 'uuid';
import StatusValidacaoSecao from '../components/StatusValidacaoSecao'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import Correcoes from '../components/Correcoes'
import EmailCorrecoes from '../components/EmailCorrecoes'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

const PerfilAnual = (props) => {

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()

    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    
    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    const formulario_id = props.formulario_id

    var [login_id, setLoginId] = useState(sessionStorage.getItem('login_id'))
    //var [adesao_institucional_id, setAdesaoInstitucionalId] = useState(sessionStorage.getItem('adesao_institucional_id'))

    var [complexidade, setComplexidade] = useState('')
    var [especializacao, setEspecializacao] = useState('')
    var [leitosOcupados, setLeitosOcupados] = useState('')
    var [salasCirurgia, setSalasCirurgia] = useState('')
    //var [empregados, setEmpregados] = useState('')
    var [consultorios, setConsultorios] = useState('')
    var [terceiroNutricao, setTerceiroNutricao] = useState(false)
    var [terceiroLavanderia, setTerceiroLavanderia] = useState(false)
    var [terceiroResiduos, setTerceiroResiduos] = useState(false)
    var [areaConstruida, setAreaConstruida] = useState('')
    var [perfilAnual_id, setPerfilAnual_id] = useState()
    var [especializadoOutros_descri, setEspecializadoOutros_descri] = useState('')

    var [hospitalEspecializado, setHospitalEspecializado] = useState('')


    var [numeroFuncionariosTFE, setnumeroFuncionariosTFE] = useState('')
    var [horasTrabalhadasTFE, sethorasTrabalhadasTFE] = useState('')

    var [terceiroNutricaoDentro, setTerceiroNutricaoDentro] = useState(false)
    var [terceiroLavanderiaDentro, setTerceiroLavanderiaDentro] = useState(false)
    var [terceiroResiduosDentro, setTerceiroResiduosDentro] = useState(false)


    var [tfe, setTFE] = useState([])
    var [listaTFE, setListaTFE] = useState()
    var [totalTFE, setTotalTFE] = useState(0)

    var [totalPendencias, setTotalPendencias] = useState(0)
    var [totalEmails, setTotalEmails] = useState(0)
    var [totalCorrecoes, setTotalCorrecoes] = useState(0)


    const [unidadesVinculadasperfil, setUnidadesVinculadasperfil] = useState([])


    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()
    const [questao3, setQuestao3] = useState()
    const [questao4, setQuestao4] = useState()
    const [questao5, setQuestao5] = useState()
    const [questao6, setQuestao6] = useState()
    const [questao7, setQuestao7] = useState()
    const [questao8, setQuestao8] = useState()
    const [questao9, setQuestao9] = useState()
    


    function adicionaFTE() {

        if (numeroFuncionariosTFE != '' && horasTrabalhadasTFE != '') {

            var tfeX = eval((parseFloat(numeroFuncionariosTFE) * parseFloat(horasTrabalhadasTFE)) / 40)
		    var tfeX = tfeX.toFixed(2)

            var tfe_ = {

                numeroFuncionariosTFE: numeroFuncionariosTFE,
                horasTrabalhadasTFE: horasTrabalhadasTFE,
                tfe: tfeX,
                key: uuidv4()

            }

            setTFE([...tfe, tfe_])
                

        }

    }





    function removeTFE(key, id) {

        if (id) {

            setTFE(tfe.filter(item => item.tfe_id !== key));
            
        } else {

            setTFE(tfe.filter(item => item.key !== key));

        }
        

    }


    function listaTFEs() {

        if (tfe) {

            setListaTFE(tfe.map((rs) => {

                return (
    
                    <tr key={rs.key ? rs.key : rs.tfe_id}>
                        <td>
                            <center>
                            {rs.numeroFuncionariosTFE}
                            </center>
                        </td>
                        <td>
                            <center>
                            {rs.horasTrabalhadasTFE}
                            </center>
                        </td>
                        <td>
                            <center>
                            {rs.tfe}
                            </center>
                        </td>
                        
                    </tr>
                )
    
            }
            
            
            ))
    
    
            var total = 0
    
            //console.log(tfe)
    
            for (var i = 0; i < tfe.length; i++) {
    
                var total = total + parseFloat(tfe[i].tfe)
    
            }
    
            setTotalTFE(total.toFixed(2))
            
        }

        
            
    }




    async function carregaPerfilAnual() {

        setComplexidade('')
        setEspecializacao('')
        setLeitosOcupados('')
        setSalasCirurgia('')
        setConsultorios('')
        setAreaConstruida('')
        setTerceiroLavanderia(false)
        setTerceiroNutricao(false)
        setTerceiroResiduos(false)
        setTFE('')
        setPerfilAnual_id()
        setListaTFE()
        setTotalTFE()
        setHospitalEspecializado('')

        setTerceiroLavanderiaDentro(false)
        setTerceiroNutricaoDentro(false)
        setTerceiroResiduosDentro(false)
        
        

        if (adesao_institucional_id) {


            await api.get(`perfilAnual/${adesao_institucional_id}/${ano}`).then((result) => {

                //console.log(result.data)

                if (result.data.perfil) {

                    var data = result.data.perfil
                    
                    setPerfilAnual_id(data.perfilAnual_id)
                    setComplexidade(data.complexidade)
                    setEspecializacao(data.especializacao)
                    setLeitosOcupados(data.leitosOcupados)
                    setSalasCirurgia(data.salasCirurgia)
                    setConsultorios(data.consultorios)
                    setAreaConstruida(data.areaConstruida)
                    setTerceiroLavanderia(data.terceiroLavanderia)
                    setTerceiroNutricao(data.terceiroNutricao)
                    setTerceiroResiduos(data.terceiroResiduos)
                    setHospitalEspecializado(data.hospitalEspecializado == true ? '1' : data.hospitalEspecializado == false ? '0' : '')

                    setTerceiroLavanderiaDentro(data.terceiroLavanderiaDentro)
                    setTerceiroNutricaoDentro(data.terceiroNutricaoDentro)
                    setTerceiroResiduosDentro(data.terceiroResiduosDentro)

                    //console.log(result.data.tfe)

                    setTFE(result.data.tfe)

                }

                


            }).catch((err) => {

                console.log(err.response)

            })

        }



    }




    const listaEmailsCorrecoes = () => {

        if (perfilAnual_id) {

            
            api.get(`emailsCorrecoesDesafio/${perfilAnual_id}`).then((result) => {

            
                setTotalEmails(result.data.length)
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })
    
        }

    }


    /*
    
    const verificaValidacoes = () => {

        //console.log('verificado')
        

        if (formulario_id) {

            var dataPost = {

                formulario_id: formulario_id,
                desafio: 'PerfilAnual',

            }

            console.log(dataPost)

            api.post('desafioValidaVarios', dataPost).then((result) => {

                if (result.data) {

                    setTotalCorrecoes(result.data.length)
                    
                }
                
              

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }
    */

    const verificaValidacoes = () => {

        //console.log(perfilAnual_id, 'aqq')
          //console.log('🔎 verificaValidacoes EXECUTOU')

        setQuestao1()
        setQuestao2()
        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()
        setQuestao7()
        setQuestao8()
        setQuestao9()


        if (perfilAnual_id) {

            var dataPost = {

                formulario_id: perfilAnual_id,
                desafio: 'PerfilAnual',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                console.log(result.data, 'aquiii')
                var data = result.data
                var totalErros = 0

                setTotalCorrecoes(data.length)

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {





                            // enunciados do perfil padrão



                            case 'Tipo de unidade de saúde por complexidade dos serviços prestados':

                                setQuestao1('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Sua unidade de saúde é um hospital especializado?':

                                setQuestao2('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Média anual de paciente-dia':

                                setQuestao3('red')
                                totalErros = totalErros + 1
                                
    
                            break

                            case 'Número de salas de cirurgia em funcionamento':

                                setQuestao4('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Número de empregados em equivalência de tempo integral – FTE':

                                setQuestao5('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Número de consultórios associados ao hospital ou unidade de saúde?':

                                setQuestao6('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Serviços executados em instalações situadas em locais fora (ex situ) sua unidade':

                                setQuestao7('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Serviços executados em instalações situadas em locais dentro (in situ) sua unidade':

                                setQuestao8('red')
                                totalErros = totalErros + 1
    
                            break

                            case 'Área construída total da unidade (em m²)':

                                setQuestao9('red')
                                totalErros = totalErros + 1
    
                            break

                        }

                    }

                    

                }

                setTotalPendencias(totalErros)


            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    useEffect(() => {
        
        if (!perfilAnual_id) {
            return
        }

        verificaValidacoes()
        listaEmailsCorrecoes()

    }, [verificaDesafio, formulario_id, perfilAnual_id])


    useEffect(() => {

        window.$('[href="#tabP1"]').tab('show');

        if (ano) {

        carregaPerfilAnual()

        }

    }, [ano, adesao_institucional_id])



    useEffect(() => {

        
        listaTFEs()

        setnumeroFuncionariosTFE('')
        sethorasTrabalhadasTFE('')

    }, [tfe])


    function salvaPerfilAnual() {

        if (complexidade == '') {

            window.toastr.error('<b>Tipo de unidade de saúde por complexidade dos serviços prestados</b> não pode ficar em branco!')
            return false

        }

        if (especializacao == '') {

            window.toastr.error('<b>Sua unidade de saúde é um hospital especializado</b> não pode ficar em branco!')
            return false

        }

        if (leitosOcupados == '') {

            window.toastr.error('<b>Média anual de paciente-dia</b> não pode ficar em branco!')
            return false

        }

        if (salasCirurgia == '') {

            window.toastr.error('<b>Número de salas de cirurgia</b> não pode ficar em branco!')
            return false

        }


        if (consultorios == '') {

            window.toastr.error('<b>Número de consultórios associados ao hospital ou unidade de saúde</b> não pode ficar em branco!')
            return false

        }

        if (hospitalEspecializado == '') {


            window.toastr.error('<b>Hospital Especializado</b> não pode ficar em branco!')
            return false


        }


        var dataPost = {

            complexidade: complexidade,
            especializacao: especializacao,
            leitosOcupados: leitosOcupados,
            salasCirurgia: salasCirurgia,
            //empregados: empregados,
            consultorios: consultorios,
            terceiroNutricao: terceiroNutricao,
            terceiroLavanderia: terceiroLavanderia,
            terceiroResiduos: terceiroResiduos,
            areaConstruida: areaConstruida,
            especializadoOutros_descri: especializadoOutros_descri,
            ano: ano,
            login_id: login_id,
            adesao_institucional_id: adesao_institucional_id,
            tfe: tfe,
            hospitalEspecializado: hospitalEspecializado,

        }


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {

                    if (perfilAnual_id) {


                        api.put(`perfilAnual/${perfilAnual_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    } else {

                        api.post('perfilAnual', dataPost).then((result) => {

                            //console.log(result.data[0].perfilAnual_id, '!!')
                            setPerfilAnual_id(result.data[0].perfilAnual_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            //history.push('/Obrigado')

                
                        }).catch((err) => {
                
                            console.log(err.response)
                
                        })

                    }

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });




    }



   


    async function geraPDF() {


        await api.get(`perfilAnualPDF/${adesao_institucional_id}/${ano}`).then((result) => {

            if (result.data) {

                window.open(`https://cdn.hospitaissaudaveis.org/pdf/${result.data.arquivo}`)

            }

            
        }).catch((err) => {

            console.log(err.response)

        })

    }




    return (

        <div>

                <div className="modal fade" id="modalPerfilAnual" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document"   style={{ width: '95%'}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Perfil Anual - {ano}</h1>
                            </div>
                            <div class="modal-body">
                                
                                <div class="panel-body">


                                <div className="row">

                                        <div className="col-md-12">


                                                <ul class="nav nav-tabs">
                                                        <li class="active"><a href="#tabP1" data-toggle="tab">Perfil Anual</a></li>
                                                        <li><a href="#tabP2" data-toggle="tab">Correções ({totalCorrecoes})</a></li>
                                                        <li><a href="#tabP3" data-toggle="tab">E-mails ({totalEmails})</a></li>
                                                </ul>

                                                <div class="tab-content">
                                                    <div class="tab-pane fade in active" id="tabP1">
                                                        <div class="panel-body">

                                                            


                                                                {
                                                                    /*

                                                                        <div className="col-md-12">
                                                                    
                                                                        <Table striped bordered hover >
                                                            
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style={{backgroundColor: '#e6f7ec'}} colSpan='2'>
                                                                                    
                                                                                        <Link style={{ color: questao1 }} onClick={() => {setEnunciado('Tipo de unidade de saúde por complexidade dos serviços prestados');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                        Tipo de unidade de saúde por complexidade dos serviços prestados
                                                                                        </Link>
                                                                                        
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ width: '100px'}}><center><input type="radio" name="complexidade" onClick={() => setComplexidade('B')} checked={ complexidade == 'B' ? 1 : 0} disabled /></center></td>
                                                                                    <td>
                                                                                        Baixa complexidade
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ width: '100px'}}><center><input type="radio" name="complexidade" checked={ complexidade == 'M' ? 1 : 0}  onClick={() => setComplexidade('M')}  disabled /></center></td>
                                                                                    <td>
                                                                                        Média complexidade
                                                                                        
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ width: '100px'}}><center><input type="radio" name="complexidade" onClick={() => setComplexidade('A')} checked={ complexidade == 'A' ? 1 : 0} disabled /></center></td>
                                                                                    <td>
                                                                                        Alta complexidade
                                                                                        
                                                                                    </td>                                
                                                                                </tr>

                                                                                <tr>
                                                                                    <td style={{ width: '100px'}}><center><input type="radio" name="complexidade" onClick={() => setComplexidade('T')} checked={ complexidade == 'T' ? 1 : 0} disabled/></center></td>
                                                                                    <td>
                                                                                        Alta complexidade com transplante de orgão
                                                                                            
                                                                                    </td>                                
                                                                                </tr>

                                                                            </tbody>
                                                                        </Table>
                                                                    

                                                                    </div>

                                                                    <div className="col-md-12">

                                                                        <Table striped bordered hover>
                                                                            
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style={{backgroundColor: '#e6f7ec'}} colSpan='2'>

                                                                                    

                                                                                    <Link style={{ color: questao2 }} onClick={() => {setEnunciado('Sua unidade de saúde é um hospital especializado?');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                    Sua unidade de saúde é um hospital especializado?
                                                                                    </Link>

                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td colspan="2">
                                                                                        <select className="form-control" value={hospitalEspecializado} onChange={event => setHospitalEspecializado(event.target.value)} disabled>
                                                                                            <option value="">[Selecione]</option>
                                                                                            <option value='0'>Não</option>
                                                                                            <option value='1'>Sim</option>
                                                                                        </select>
                                                                                    </td>
                                                                                </tr>
                                                                                
                                                                                <tr style={{ display: hospitalEspecializado == '1' ? 'table-row' : 'none'}}>
                                                                                    <td colspan="2" >Favor assinalar abaixo a opção aplicável:</td>
                                                                                </tr>
                                                                                <tr style={{ display: 'none'}}>
                                                                                    <td style={{ width: '100px'}}><input type="radio" name="especializacao" onClick={() => setEspecializacao('X')} checked={ especializacao == 'X' ? 1 : 0} disabled /></td>
                                                                                    <td>
                                                                                        Não sou hospital especializado
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr style={{ display: hospitalEspecializado == '1' ? 'table-row' : 'none'}}>
                                                                                    <td style={{ width: '100px'}}><input type="radio" name="especializacao" onClick={() => setEspecializacao('C')} checked={ especializacao == 'C' ? 1 : 0} disabled /></td>
                                                                                    <td>
                                                                                    Cardiologia
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr style={{ display: hospitalEspecializado == '1' ? 'table-row' : 'none'}}>
                                                                                    <td style={{ width: '100px'}}><input type="radio" name="especializacao" onClick={() => setEspecializacao('M')} checked={ especializacao == 'M' ? 1 : 0} disabled /></td>
                                                                                    <td>
                                                                                        Maternidade/ Obstetricia/ Ginecologia
                                                                                    </td>                                
                                                                                </tr>

                                                                                <tr style={{ display: hospitalEspecializado == '1' ? 'table-row' : 'none'}}>
                                                                                    <td style={{ width: '100px'}}><input type="radio" name="especializacao" onClick={() => setEspecializacao('N')} checked={ especializacao == 'N' ? 1 : 0} disabled /></td>
                                                                                    <td>
                                                                                        Oncologia
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr style={{ display: hospitalEspecializado == '1' ? 'table-row' : 'none'}}>
                                                                                    <td style={{ width: '100px'}}><input type="radio" name="especializacao" onClick={() => setEspecializacao('P')} checked={ especializacao == 'P' ? 1 : 0} disabled /></td>
                                                                                    <td>
                                                                                    Pediatria
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr style={{ display: hospitalEspecializado == '1' ? 'table-row' : 'none'}}>
                                                                                    <td style={{ width: '100px'}}><input type="radio" name="especializacao" onClick={() => setEspecializacao('S')} checked={ especializacao == 'S' ? 1 : 0} disabled /></td>
                                                                                    <td>
                                                                                    Psiquiatria
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr style={{ display: hospitalEspecializado == '1' ? 'table-row' : 'none'}}>
                                                                                    <td style={{ width: '100px'}}><input type="radio" name="especializacao" onClick={() => setEspecializacao('O')} checked={ especializacao == 'O' ? 1 : 0} disabled /></td>
                                                                                    <td>
                                                                                    Outros
                                                                                    </td>                                
                                                                                </tr>
                                                                                <tr style={{ display: especializacao == 'O' ? 'table-row' : 'none' }}>
                                                                                    <td colspan="2">
                                                                                        <textarea className="form-control" rows="5" placeholder="Descreva..." value={especializadoOutros_descri} onChange={event => setEspecializadoOutros_descri(event.target.value)} disabled />
                                                                                    </td>                                
                                                                                </tr>

                                                                            </tbody>
                                                                        </Table>

                                                                    </div>

                                                                    */
                                                                }

                                                                

                                                                <div className="col-md-12">
                                                                    <div class="form-group" >
                                                                        <label className="control-label">
                                                                                <b>
                                                                                    
                                                                                    <Link to='#' style={{ color: questao3 }} onClick={() => {setEnunciado('Média anual de paciente-dia');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                    Média anual de paciente-dia
                                                                                    </Link>
                                                                                    
                                                                                </b><br/> (Considerar a ocupação média anual no ano de relato)*:</label>
                                                                        <input class="form-control" value={leitosOcupados} onChange={event => setLeitosOcupados(event.target.value)}  disabled
                                                                        onKeyPress={(event) => {
                                                                            if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                            
                                                                            }
                                                                        }}  />
                                                                            

                                                                    </div>
                                                                    

                                                                </div>


                                                                <div className="col-md-12">
                                                                    <div class="form-group" >
                                                                        <label className="control-label">
                                                                                    
                                                                                    <Link to='#' style={{ color: questao4 }} onClick={() => {setEnunciado('Número de salas de cirurgia em funcionamento');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                    Número de salas de cirurgia em funcionamento
                                                                                    </Link>
                                                                                    <br/>
                                                                                (Considerar valor médio anual das salas de cirurgia em funcionamento)</label> 
                                                                        <input class="form-control" value={salasCirurgia} onChange={event => setSalasCirurgia(event.target.value)}  disabled
                                                                        onKeyPress={(event) => {
                                                                            if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                            }
                                                                        }}  />
                                                                            

                                                                    </div>
                                                                    

                                                                </div>





                                                                <div className="col-md-12">
                                                            

                                                            <Table striped bordered hover>
                                                                    
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{backgroundColor: '#e6f7ec'}} colSpan='2'>


                                                                            <Link to='#' style={{ color: questao5 }} onClick={() => {setEnunciado('Número de empregados em equivalência de tempo integral – FTE');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                            Número de empregados em equivalência de tempo integral – FTE
                                                                            </Link>
                                                                            <br/>
                                                                            (Considerar valor médio anual de salas de cirurgia em funcionamento)  
                                                                            

                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>


                                                                                No cálculo do FTE deve incluir todos os trabalhadores que atuam na unidade, independente dos tipos de vínculos, inclusive terceirizados, ou mesmo voluntários, sempre considerando as respectivas cargas horárias semanais. 
                                                                                <br/><br/>
                                                                                Nosso sistema utiliza o “FTE Diário”, por ser de compreensão mais fácil e ser mais adequado aos nossos objetivos como monitorar a geração de resíduos ou as emissões de GEE por funcionário. 
                                                                                <br/><br/>


                                                                                <b>Veja exemplos de como computar as horas semanais de cada regime de trabalho através de alguns exemplos mais comuns:</b>

                                                                                <ul>

                                                                                <li>8 horas/dia x 5 dias por semana = 40 horas semanais;</li>

                                                                                <li>8 horas de segunda a sexta + 4 horas aos sábados = 44 horas semanais;</li>

                                                                                <li>4 horas/dia x 6 dias por semana = 24 horas semanais;</li>

                                                                                <li>plantão “12 por 36” com 1 folga quinzenal = 36 horas semanais.</li>

                                                                                </ul>


                                                                                <b>Preencha na tabela abaixo os dados solicitados para calcular o FTE de forma automática</b>

                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                            </Table>


                                                                <Table striped bordered hover>
                                                                    <thead>
                                                                        <tr>
                                                                        <th><center>N<sup>o</sup> de funcionários</center></th>
                                                                        <th><center>N<sup>o</sup> de horas trabalhadas por semana</center></th>
                                                                        <th><center>FTE diário</center></th>
                                                                        
                                                                        
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                            {listaTFE}
                                                                            <tr>
                                                                                <td colspan="2">
                                                                                    <center>
                                                                                    <b>Total</b>
                                                                                    </center>
                                                                                </td>
                                                                                <td>
                                                                                    <center>
                                                                                    <b>{totalTFE}</b>
                                                                                    </center>
                                                                                </td>
                                                                                
                                                                            </tr>
                                                                            
                                                                    
                                                                    </tbody>
                                                                </Table>


                                                            </div>


                                                            <div className="col-md-12">
                                                                <div class="form-group" >
                                                                    <label className="control-label">

                                                                        <Link to='#' style={{ color: questao6 }} onClick={() => {setEnunciado('Número de consultórios associados ao hospital ou unidade de saúde?');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                            Número de consultórios associados ao hospital ou unidade de saúde?
                                                                        </Link>
                                                                        
                                                                        </label>
                                                                    <input class="form-control" value={consultorios} onChange={event => setConsultorios(event.target.value)} disabled 
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                        event.preventDefault();
                                                                        }
                                                                    }} />
                                                                </div>
                                                                Caso tenha havido variação no número de consultórios durante o ano considerado, calcular o valor médio mediante a fórmula: Número de consultórios = soma das médias mensais de consultórios em funcionamento durante o ano em questão dividida por 12


                                                            </div>

                                                            <div className="col-md-12">

                                                                <br/>

                                                                <Table striped bordered hover>
                                                
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{backgroundColor: '#e6f7ec'}} colSpan='2'>
                                                                                
                                                                                <Link to='#' style={{ color: questao7 }} onClick={() => {setEnunciado('Serviços executados em instalações situadas em locais fora (ex situ) sua unidade');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                Serviços executados em instalações situadas em locais fora (ex situ) sua unidade
                                                                                </Link>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ width: '100px'}}>
                                                                                
                                                                                
                                                                                
                                                                                <select value={terceiroNutricao} onChange={event => setTerceiroNutricao(event.target.value)} disabled>

                                                                                    <option value=''>[Selecione]</option>
                                                                                    <option value={true}>Sim</option>
                                                                                    <option value={false}>Não</option>

                                                                                </select>

                                                                                </td>
                                                                            <td>
                                                                                Nutrição e dietética (cozinha)
                                                                            </td>                                
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ width: '100px'}}>
                                                                                
                                                                                <select value={terceiroLavanderia} onChange={event => setTerceiroLavanderia(event.target.value)} disabled>

                                                                                    <option value=''>[Selecione]</option>
                                                                                    <option value={true}>Sim</option>
                                                                                    <option value={false}>Não</option>

                                                                                </select>
                                                                                
                                                                            </td>
                                                                            <td>
                                                                                Lavanderia
                                                                            </td>                                
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ width: '100px'}}>
                                                                                
                                                                                <select value={terceiroResiduos} onChange={event => setTerceiroResiduos(event.target.value)} disabled>

                                                                                    <option value=''>[Selecione]</option>
                                                                                    <option value={true}>Sim</option>
                                                                                    <option value={false}>Não</option>

                                                                                </select>
                                                                                
                                                                            </td>
                                                                            <td>
                                                                                Tratamento de resíduos
                                                                            </td>                                
                                                                        </tr>


                                                                    </tbody>
                                                                </Table>

                                                            </div>

                                                            <div className="col-md-12">

                                                                <br/>

                                                                <Table striped bordered hover>
                                                
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{backgroundColor: '#e6f7ec'}} colSpan='2'>
                                                                                
                                                                                <Link to='#' style={{ color: questao8 }} onClick={() => {setEnunciado('Serviços executados em instalações situadas em locais dentro (in situ) sua unidade');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                Serviços executados em instalações situadas em locais dentro (in situ) sua unidade
                                                                                </Link>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ width: '100px'}}>
                                                                                    
                                                                                    <select value={terceiroNutricaoDentro} onChange={event => setTerceiroNutricaoDentro(event.target.value)} disabled>

                                                                                        <option value=''>[Selecione]</option>
                                                                                        <option value={true}>Sim</option>
                                                                                        <option value={false}>Não</option>

                                                                                    </select>
                                                                                    
                                                                            </td>
                                                                            <td>
                                                                                Nutrição e dietética (cozinha)
                                                                            </td>                                
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ width: '100px'}}>
                                                                                
                                                                                <select value={terceiroLavanderiaDentro} onChange={event => setTerceiroLavanderiaDentro(event.target.value)} disabled>

                                                                                    <option value=''>[Selecione]</option>
                                                                                    <option value={true}>Sim</option>
                                                                                    <option value={false}>Não</option>

                                                                                </select>
                                                                                
                                                                            </td>
                                                                            <td>
                                                                                Lavanderia
                                                                            </td>                                
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ width: '100px'}}>
                                                                                

                                                                                <select value={terceiroResiduosDentro} onChange={event => setTerceiroResiduosDentro(event.target.value)} disabled>

                                                                                    <option value=''>[Selecione]</option>
                                                                                    <option value={true}>Sim</option>
                                                                                    <option value={false}>Não</option>

                                                                                </select>
                                                                                
                                                                            </td>
                                                                            <td>
                                                                                Tratamento de resíduos
                                                                            </td>                                
                                                                        </tr>


                                                                    </tbody>
                                                                </Table>

                                                            </div>


                                                            <div className="col-md-12">
                                                                <Table striped bordered hover>
                                                                    
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{backgroundColor: '#e6f7ec'}} colSpan='2'>

                                                                                <Link to='#' style={{ color: questao9 }} onClick={() => {setEnunciado('Área construída total da unidade (em m²)');setSecaoEnunciado('Perfil Anual');window.$('#modalValidacao').modal('show')}}>
                                                                                Área construída total da unidade (em m²)
                                                                                </Link>

                                                                                <br/>
                                                                                Somente números inteiros
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                            <input class="form-control" value={areaConstruida} onChange={event => setAreaConstruida(event.target.value)}  disabled
                                                                            onKeyPress={(event) => {
                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                event.preventDefault();
                                                                                }
                                                                            }} />
                                                                            
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                                
                                                                
                                                                


                                                            </div>

                                                            
                                                            <StatusValidacaoSecao desafio="PerfilAnual" secaoCampo="situacao" totalPendencias={totalPendencias} nomeDesafio="Perfil Anual" formulario_id={perfilAnual_id} secao="Perfil Anual" adesao_institucional_id={adesao_institucional_id} ano={ano} />     




                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade in" id="tabP2">
                                                        <div class="panel-body">
                                                            
                                                            
                                                            <Correcoes adesao_institucional_id={adesao_institucional_id} formulario_id={perfilAnual_id} ano={ano}  origem="PerfilAnual" />



                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade in" id="tabP3">
                                                        <div class="panel-body">
                                                            

                                                            <EmailCorrecoes adesao_institucional_id={adesao_institucional_id} formulario_id={perfilAnual_id} ano={ano}  origem="PerfilAnual" />


                                                        </div>
                                                    </div>
                                                </div>

                                        </div>

                                        
                                        

                                        


                                        
                                

                                    


                                    
                                    
                                    
                                </div>

                                

                                
                                

                                </div>

                                

                                    



                            
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => geraPDF()}>PDF</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


                

        </div>

    )

}


export default PerfilAnual